// extracted by mini-css-extract-plugin
export default {"container":"Business_container__zdqeV"};